// Story 221 (RN10, RN11, RN17): once the plan's options arrive, a Fabrication Order or Order filter whose id is
// no longer among them is cleared; Part Reference and Client keep their catalogue and are never touched. The
// SAME object comes back when nothing changes: `Calendar.jsx:288,578`, `usePlanMetrics` and `useDeliveries`
// reload on the identity of `plannerFilters`, so a fresh copy would reload the Gantt and the blocks for nothing.
const hasOption = (options, id) => options.some((option) => option.id === id)

export const reconcilePlannerFilters = (filters, { fabricationOrders, orders }) => {
  const fabricationOrderId = hasOption(fabricationOrders, filters.fabricationOrderId) ? filters.fabricationOrderId : null
  const orderId = hasOption(orders, filters.orderId) ? filters.orderId : null
  if (fabricationOrderId === filters.fabricationOrderId && orderId === filters.orderId) {
    return filters
  }
  return { ...filters, fabricationOrderId, orderId }
}
